<ng-container *ngIf="mapData.length; else emptyTmpl">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'drill-down'">
      <ng-container *ngIf="mapData.length === 1">
        <ng-container *ngTemplateOutlet="tmpl; context: { data: mapData[0] }"></ng-container>
      </ng-container>
      <ng-container *ngIf="mapData.length > 1">
        <ng-container *ngTemplateOutlet="defaultTmpl; context: { data: mapData }"></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="defaultTmpl; context: { data: mapData }"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<!--  -->
<ng-template let-data="data" #defaultTmpl>
  <p500-ui-many-items
    [data]="data"
    i18n-title="@@common.answers"
    title="Answers"
    [tmpl]="tmpl"
    [previewTmpl]="previewTmpl"
    [buttonTmpl]="buttonTmpl"
  >
  </p500-ui-many-items>
  <ng-template let-data="data" #previewTmpl> </ng-template>
  <ng-template let-open="open" #buttonTmpl>
    <div class="c-field-value c-field-value--view-mode d-flex">
      <span class="c-field-value__icon" (click)="open($event)">
        <p500-ui-icon name="menu-eye"></p500-ui-icon>
      </span>
      <span i18n="@@common.show">Show</span>
    </div>
  </ng-template>
</ng-template>
<!--  -->
<ng-template let-data="data" #tmpl>
  <div class="font-body-4">
    <div class="fw-bold" *ngIf="data.question">
      <gtd-ui-field-default-string-whitespace-or-empty [data]="data.question"> </gtd-ui-field-default-string-whitespace-or-empty>
    </div>
    <ng-container *ngIf="data.answers?.length; else emptyTmpl">
      <div *ngFor="let item of data.answers">
        <ng-container *ngIf="item || data.answers?.length === 1">
          <gtd-ui-field-default-string-whitespace-or-empty [data]="item"> </gtd-ui-field-default-string-whitespace-or-empty>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>
<!--  -->
<ng-template #emptyTmpl>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
